import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const PageBanner = ({ title }) => (
  <div className="page-banner">
    <h1 className="page-banner__title">{title}</h1>
  </div>
);

PageBanner.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PageBanner;
